// import moment from "moment";
import React, { Component } from "react";
import "react-datepicker/dist/react-datepicker.css";
import UI from "../../shared/Components/UI/js";
import {
  Image,
  mem,
  Shadow,
  StyleSheet,
  Text,
  TouchableOpacity,
  View,
} from "../../shared/custom-react-native";
import APIConstants from "../../shared/modules/APIConstants";
import CustomDatatable from "../_components/CustomDatatable";
import EntryPicker from "../_components/EntryPicker";
import InputForm from "../_components/InputForm";
import Layout from "../_components/Layout";
import MainLayout from "../_components/MainLayout";
// import { DeleteConfirmation } from "../_components/Modal";
import CSVFormat from "./CSVFormat";

const context = "advocacy";
const Constants = new APIConstants();

export default class AdvocacyTransactions extends Component {
  constructor(props) {
    super(props);
    UI.initiateView(this, {
      //Initial State Here
      active_tab: "Transactions",
      is_drawer_open: false,
      current_page: 1,
      number_of_pages: 1,
      data: [],
      all_data: [],
      context: context,
    });
  }

  onCreate = async () => {
    // setTimeout(() => {
      this.get_data({
        page: 1,
        limit:
          this.state["advocacy_entries"] ??
          30,
      });
    // }, 100);
  };

  get_data = async (params, reload) => {
    let limit = parseInt(params.limit);
    params.limit = limit >= 30 ? 30 : limit
    this.show_loading();
    if (!params) {
      params = {};
    }

    this.setState({
      current_page: params?.page ?? 1,
    });

    UI.webRequest({
      method: "get",
      url: "admin/advocacies/transactions",
      params: params,
      onFail: async (err) => {},
      onSuccess: async (response) => {
        const data = UI.extract_data(response);
        const results = UI.get_results(response);

        if (!results?.total) {
          results.total = results.docCount;
        }
        this.setState(
          {
            data: data.data,
            all_data: data.data,
          },
          () => {
            UI.get_entries(
              data.data,
              params.limit ?? 30,
              "advocacy",
              params.page,
              {
                total: results.total,
                pages: results.pages,
              }
            );
            // this.hide_loading();
          }
        );
      },
      onFinish: () => {
        this.hide_loading();
      },
    });
  };

  sort_by = (format, key, page) => {
    //format can be asc or desc
    if(key === "valid_until") {
      this.get_data({
        validUntil:format,
        page: page ? page : 1,
        limit:
          this.state["advocacy_entries"] ??
          30,
      });
      // this.setState({
      //   sortDateAdded: {
      //     format,
      //     key,
      //   }
      // })
    } else if (key === "created_at") {
      this.get_data({
        startDate:format,
        page: page ? page : 1,
        limit:
          this.state["advocacy_entries"] ??
          30,
      });
      // this.setState({
      //   sortPatientName: {
      //     format,
      //     key,
      //   }
      // })
    }
  };

  custom_sort = (key, value, page) => {
    if(value === "default") {
      this.get_data({
        page: 1,
        limit:
          this.state["advocacy_entries"] ??
          30,
      });
    } else {
      this.get_data({
        status :value,
        page: page ? page : 1,
        limit:
          this.state["advocacy_entries"] ??
          30,
      });
    }
  };


  export_to_csv = async () => {
    const { all_data } = this.state;

    const csv_data = all_data.map((item, index) => {
      // const d = {
      //   Row: index + 1,
      //   "Advocacy Name": item.title ?? " ",
      //   "Activity Type": item.promotionCode ?? " ",
      //   "User Type": item.status ?? " ",
      //   "Name": item.description ?? " ",
      //   "Activity Date": item.createdAt ?? " ",
      // };
      const d = CSVFormat.create(item, index);
    
      return d;
    });

    UI.DownloadCSV(
      "All Transactions " + UI.get_current_date_string(),
      csv_data
    );
  };

  render() {
    const _this = this;
    const {  width } = _this.state;
    return (
      <MainLayout context={context} _this={_this}>
        <View style={styles.main_box_content}>
          <Text style={styles.box_header_text}>Transaction List</Text>
          {UI.box(20)}
          <UI.Row breakpoint={840} _this={_this}>
            <Layout.SelectPicker
              _this={_this}
              title={"Activity Type"}
              isRequired={false}
              onChange={(e) => {
                this.custom_sort("activity_type", e);
              }}
            >
              <option value="default">Select Status</option>
              <option value="Active">Active</option>
              <option value="Inactive">Inactive</option>
            </Layout.SelectPicker>

            {UI.box(10)}
            <Layout.SelectPicker
              _this={_this}
              title={"Activity Date"}
              isRequired={false}
              onChange={(e) => {
                this.sort_by(e, "activity_date");
              }}
            >
              <option value="asc">Ascending</option>
              <option value="desc">Descending</option>
            </Layout.SelectPicker>
            
            {UI.box(10)}
            <Layout.SelectPicker
              _this={_this}
              title={"Advocacy Name"}
              isRequired={false}
              onChange={(e) => {
                this.sort_by(e, "advocacy_name");
              }}
            >
              <option value="asc">Ascending</option>
              <option value="desc">Descending</option>
            </Layout.SelectPicker>
          </UI.Row>
        </View>

        <View style={{ ...styles.main_box_content, padding: 0, marginTop: 20 }}>
          <UI.Row
            style={styles.main_container_header}
            breakpoint={950}
            _this={_this}
          >
            <View
              style={{ flexDirection: "row", alignItems: "center", flex: 1 }}
            >
              <Text style={styles.entry_header}>Only Show</Text>
              {UI.box(10)}
              <View>
                <EntryPicker
                  isAppointmentPage={true}
                  stateless={true}
                  callback={this.onCreate}
                  table_name={"advocacy"}
                  _this={_this}
                />
              </View>
            </View>

            <InputForm
              _this={_this}
              title={""}
              is_keyword={true}
              placeholder={"Enter Keyword"}
              state_name={"search"}
              onChange={(e) => {
                UI.search_table("advocacy", e, this.state.all_data, "data");
              }}
              right={
                <TouchableOpacity style={styles.search_btn}>
                  <Image
                    height={17}
                    width={17}
                    tintColor={"transparent"}
                    source={UI.SEARCH}
                  />
                </TouchableOpacity>
              }
              disableLength={true}
              maxLength={UI.Constants.limits.keyword}
            />

            <View
              style={{
                alignSelf: width > 950 ? "flex-start" : "center",
                marginTop: 8,
                marginLeft: 10,
              }}
            >
              <Layout.Btn
                color={UI.colors.primary}
                text={"Export to CSV"}
                onClick={() => {
                  this.export_to_csv();
                }}
                height={40}
                width={150}
              />
            </View>
          </UI.Row>

          <CustomDatatable
            state_name={"advocacy"}
            _this={_this}
            columns={[
              { "ID": "id" },
              { "Preview": "preview" },
              { "Advocacy Name": "title" },
              { "Activity Type": "activity_type" },
              { "User Type": "user_type" },
              { "Name": "name" },
              { "Activity Date": "activity_date" },
              { "Action": "action" },
            ]}
            data={this.state.data.map((item) => {
              // const start_date = moment(item.createdAt).format('MM/DD/YYYY');
              // const valid_until = moment(item.endDate).format('MM/DD/YYYY');
              const image = `${Constants.STORAGE_BASE_URL}?path=${item.imagePath}` ?? UI.SAMPLE_PRODUCT
              
              return {
                id: item._id,
                preview: (
                  <img src={item.imagePath ? image : UI.SAMPLE_PRODUCT} alt="" width={135}/>
                ),
                title: <Text>
                  National mWellness Day: The biggest nationwide online medical mission
                  {/* {item.title} */}
                </Text>,
                activity_type:  item.appointmentType ? 'Consult Now' : 'Consult Later' ?? '',
                user_type: "Doctor",
                name: item?.practitioner?.name[0].given[0] + " " + item?.practitioner?.name[0].family,
                activity_date: "08/27/2022",
                action: (
                  <View style={{ flexDirection: "row" }}>
                     <TouchableOpacity
                      onClick={() => {
                        mem.save("view_advocacy", JSON.stringify(item));
                        mem.save("advocacy_id", item.id);
                        UI.goTo("/advocacy/transactions-view");
                      }}
                    >
                      <Image
                        height={28}
                        width={28}
                        tintColor={"transparent"}
                        source={UI.VIEW_BTN}
                      />
                    </TouchableOpacity>
                  </View>
                ),
              };
            })}
            number_of_pages={this.number_of_pages}
            current_page={this.current_page}
            on_page={(page, callback, table_name) => {
              this.get_data({
                page: page,
                limit: parseInt(this.state.entries)
              });
            }}
          />

          <View 
            style={{
              ...styles.no_info_container,
              display: this.state.all_data.length > 0 ? "none" : "flex",
            }}
          >
            <UI.Row
              breakpoint={820}
              style={{ maxWidth: 360, alignItems: "center" }}
              _this={_this}
            >
              <Image
                height={100}
                width={100}
                tintColor={"transparent"}
                source={UI.NO_INFO}
              />
              {UI.box(10)}
              <Text
                style={{
                  fontSize: 20,
                  fontWeight: "bold",
                  color: "#BFBFBF",
                  textAlign: width > 820 ? "left" : "center",
                  marginLeft: width > 820 ? 20 : 0,
                }}
              >
                NO DATA AVAILABLE YET
              </Text>
            </UI.Row>
          </View>
        </View>
      </MainLayout>
    );
  }
}

const styles = StyleSheet.create({
  no_info_container: {
    paddingTop: 50,
    paddingBottom: 50,
    alignItems: "center",
  },
  search_btn: {
    height: 35,
    width: 35,
    justifyContent: "center",
    alignItems: "center",
    marginRight: -5,
  },
  entry_header: {
    fontSize: 14,
    fontWeight: "bold",
    color: "#2E2E2E",
  },
  main_container_header: {
    padding: 10,
    paddingLeft: 20,
    paddingRight: 20,
  },
  main_box_content: {
    borderRadius: 5,
    backgroundColor: "white",
    ...Shadow._3(),
    padding: 20,
  },
  box_header_text: {
    fontSize: 16,
    fontWeight: "bold",
    color: UI.colors.secondary,
    flex: 1,
  },
});
